/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemSettingKey } from './SystemSettingKey';
import {
    SystemSettingKeyFromJSON,
    SystemSettingKeyFromJSONTyped,
    SystemSettingKeyToJSON,
    SystemSettingKeyToJSONTyped,
} from './SystemSettingKey';
import type { JsonNode } from './JsonNode';
import {
    JsonNodeFromJSON,
    JsonNodeFromJSONTyped,
    JsonNodeToJSON,
    JsonNodeToJSONTyped,
} from './JsonNode';

/**
 * 
 * @export
 * @interface SystemSettingResponse
 */
export interface SystemSettingResponse {
    /**
     * 
     * @type {SystemSettingKey}
     * @memberof SystemSettingResponse
     */
    key: SystemSettingKey;
    /**
     * 
     * @type {JsonNode}
     * @memberof SystemSettingResponse
     */
    value: JsonNode | null;
}



/**
 * Check if a given object implements the SystemSettingResponse interface.
 */
export function instanceOfSystemSettingResponse(value: object): value is SystemSettingResponse {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function SystemSettingResponseFromJSON(json: any): SystemSettingResponse {
    return SystemSettingResponseFromJSONTyped(json, false);
}

export function SystemSettingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemSettingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'key': SystemSettingKeyFromJSON(json['key']),
        'value': JsonNodeFromJSON(json['value']),
    };
}

export function SystemSettingResponseToJSON(json: any): SystemSettingResponse {
    return SystemSettingResponseToJSONTyped(json, false);
}

export function SystemSettingResponseToJSONTyped(value?: SystemSettingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': SystemSettingKeyToJSON(value['key']),
        'value': JsonNodeToJSON(value['value']),
    };
}

